import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import { isPresent } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class CustomerInformation extends ApplicationComponent {
  renderNameEmailPhone() {
    if (isPresent("currentUser")) return null

    const contact = this.props.contact
    return [
      <div className="col-sm-4" key="name">
        <FormGroup
          label="Name"
          name="contact.name"
          value={contact.name}
          onChange={this.props.onChange}
          validation={this.props.validator.message(
            "name",
            contact.name,
            "required"
          )}
        />
      </div>,
      <div className="col-sm-4" key="email">
        <FormGroup
          label="Email"
          name="contact.email"
          value={contact.email}
          onChange={this.props.onChange}
          validation={this.props.validator.message(
            "email",
            contact.email,
            "required|email"
          )}
        />
      </div>,
      <div className="col-sm-4" key="phone">
        <FormGroup
          label="Phone"
          name="contact.phone"
          value={contact.phone}
          onChange={this.props.onChange}
          validation={this.props.validator.message(
            "phone",
            contact.phone,
            "required|phone"
          )}
        />
      </div>,
    ]
  }

  render() {
    const contact = this.props.contact
    return (
      <div>
        <h4 className="bs-mb-4 font-semibold">1. Personal Information</h4>
        <div className="row form-row">
          {this.renderNameEmailPhone()}
          <div className="col-sm-6">
            <FormGroup
              label="Address Line One"
              name="contact.address_line_one"
              value={contact.address_line_one}
              onChange={this.props.onChange}
            />
          </div>
          <div className="col-sm-6">
            <FormGroup
              label="Address Line Two"
              name="contact.address_line_two"
              value={contact.address_line_two}
              onChange={this.props.onChange}
            />
          </div>
          <div className="col-xs-5">
            <FormGroup
              label="City"
              name="contact.city"
              value={contact.city}
              onChange={this.props.onChange}
            />
          </div>
          <div className="col-xs-4">
            <FormGroup
              label="State"
              name="contact.state"
              value={contact.state}
              onChange={this.props.onChange}
            />
          </div>
          <div className="col-xs-3">
            <FormGroup
              label="Zip"
              name="contact.zip"
              value={contact.zip}
              onChange={this.props.onChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

CustomerInformation.propTypes = {
  onChange: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
  contact: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    address_line_one: PropTypes.string,
    address_line_two: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
}

export default CustomerInformation
